import {useState,useRef,useEffect} from 'react';
import Link from 'next/link';
import Image from 'next/image';
import dynamic from 'next/dynamic';
import Select from 'react-select';
import {Maps} from './../../../js/prefix.js';
import styles from './../../../css/pc/login/login.module.scss';
import { ToastContainer,toast ,Zoom} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {sendSms,resetSendSms,sendVerificationMail,verifMailCode,verifSmsCode,getQCaptEncryptAppid} from './../../../service/loginService';
import {useRouter} from 'next/router';
import {tencentCaptchaId} from '@/config/config';

const customStyles = {
    container:(provided, state)=>({
        ...provided,
        width:120,
        fontSize:16,
    }), 
    valueContainer:(provided, state)=>({
        width:100,
        fontSize:16,
    }), 
    indicatorsContainer:(provided, state)=>({
        ...provided,
        fontSize:16,
    }), 
    indicatorSeparator:(provided, state)=>({
        ...provided,
        display:'none',
    }), 
    dropdownIndicator:(provided, state)=>({
        ...provided,
        paddingRight:0
    }),
    input:(provided, state)=>({
        ...provided,
        height:36,
        lineHeight:'36px',
        margin:0,
        padding:0,
        position:'absolute',
        top:'50%',
        transform:'translateY(-50%)',
    }),
    menu: (provided, state) => ({
        ...provided,
        width:200,
        borderBottom: '1px dotted pink',
        color: state.selectProps.menuColor,
        padding: 0,
        margin:0
    }),
    menuList:(provided, state)=>({
        ...provided,
        maxHeight:'200px'
    }), 
    option:(provided, state)=>({
        ...provided,
        fontSize:16,
        color:'#8691a7',
        background:state.isSelected||state.isFocused?'#f6f6f6':'none'
    }), 
    control: (_, { selectProps: { width }}) => ({
        display:'flex',

    }),
    singleValue: (provided, state) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        return { ...provided, opacity, transition ,width:'90px'};
    }
}
const Reset_PC=(props)=>{
    try{
        const router=useRouter();
        const returnUrl=router.query.returnUrl?router.query.returnUrl:'https://www.fx168news.com';
        const sourceCode=router.query.sourceCode;
        const parameters=props.params;
        const flag=props.flag;
        const [status, setStatus] = useState(parameters.sourceStatus=='phone'?'mobile':'email');
        const [selectedOption, setSelectedOption] = useState({value: "中国+86",label: "中国+86"});
        const [captchaIns, setCaptchaIns] = useState('');
        const [pwdStatus, setPwdStatus] = useState(false);
        const [mobile, setMobile] = useState('');
        const [email, setEmail] = useState('');
        const [password, setPassword] = useState('');
        const [id, setId] = useState('');
        const [code, setCode] = useState('');
        const [codeStatus, setCodeStatus] = useState(true);
        const [count, setCount] = useState(60);
        const [loading, setLoading] = useState(false);
        const mobileRef = useRef();
        const emailRef = useRef();
        const roamRef = useRef();
        const statusRef = useRef();
        let codeCount=60;
        let timer=null;
        let captchaLoaded=false;

        useEffect(()=>{
            initCaptcha();
        },[]);

        // 定义回调函数
        const callback=(res)=> {
            if (res.ret === 0) {
                if(statusRef.current.value=='mobile'){
                    handleCodeSubmit(roamRef.current.props.value,mobileRef.current.value,res.ticket,res.randstr);
                }else{
                    handleGetEmailCode(emailRef.current.value,res.ticket,res.randstr);
                }
            }
        }
        // 定义验证码js加载错误处理函数
        const loadErrorCallback=() =>{
            var appid = tencentCaptchaId
            // 生成容灾票据或自行做其它处理
            var ticket = "terror_1001_" + appid + "_" + Math.floor(new Date().getTime() / 1000)
            callback({
                ret: 300,
                randstr: "@" + Math.random().toString(36).substr(2),
                ticket: ticket,
                errorCode: 1001,
                errorMessage: "jsload_error"
            })
        }
        const initCaptcha=async()=>{
            try {
                const result=await getQCaptEncryptAppid({});
                if(result.code==0){
                    const captcha = new TencentCaptcha(tencentCaptchaId, callback, {aidEncrypted: result.data });
                    setCaptchaIns(captcha);
                    captchaLoaded=true;
                }else{
                    toast.error('获取腾讯云验证码加密appid失败',{toastId:'customId'});
                }
            } catch (error) {
                // 加载异常，调用验证码js加载错误处理函数
                loadErrorCallback()
            }
        }
        const handlePassowordPost=(e)=>{
            const val=e.target.value;
            setPassword(val);
        }
        const handleCodePost=(e)=>{
            const val=e.target.value;
            setCode(val);
        }
        const handleMobilePost=(e)=>{
            const val=e.target.value;
            setMobile(val);
        }
        const handleEmailPost=(e)=>{
            const val=e.target.value;
            setEmail(val);
        }
        const handleGetCode=(e)=>{
            //e.preventDefault();
            if(status=='mobile'){
                let phone=trim(mobile);
                let reg=/^1[2|3|4|5|6|7|8|9]\d{9}$/;
                if(phone===''){
                    toast.error("手机号不能为空！",{toastId:'customId2'});
                    return false;
                }
                if(selectedOption.value=='中国+86'&&!reg.test(phone)){
                    toast.error("请检查手机号码！",{toastId:'customId2'});
                    return false;
                }
            }else{
                let emailVal=trim(email);
                let reg=/^([a-zA-Z]|[0-9])(\w|\-|\.)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
                if(emailVal===''){
                    toast.error("邮箱不能为空！",{toastId:'customId2'});
                    return false;
                }
                if(!reg.test(emailVal)){
                    toast.error("请检查邮箱格式！",{toastId:'customId2'});
                    return false;
                }
            }
            // 手动调用verify方法
            captchaIns && captchaIns.show();
        }
        //获取验证码提交
        const handleCodeSubmit=async(roam,mobile,captchaValidate,randstr)=>{
            let phone=roam.value.split('+')[1]=='86'?mobile:('+'+roam.value.split('+')[1]+mobile);
            setCodeStatus(false);
            timer=setInterval(function(){
                if(codeCount<=1){
                    setCodeStatus(true);
                    codeCount=60;
                    setCount(codeCount)
                    clearInterval(timer);
                }else{
                    codeCount=codeCount-1;
                    setCount(codeCount)
                }
            },1000);

            const res=await resetSendSms({mobile:phone,ticket:captchaValidate,randstr:randstr,checkVersion:1});
            if(res.code==0){
                setId(res.data.id);
                toast.success("发送成功！",{toastId:'customId2'});
            }else{
                setCodeStatus(true);
                setCount(60);
                clearInterval(timer);
                toast.error(res.data||"发送失败！",{toastId:'customId2'});
            }

        }
        const handleGetEmailCode=async(emailval,captchaValidate,randstr)=>{
            setCodeStatus(false);
            timer=setInterval(function(){
                if(codeCount<=1){
                    setCodeStatus(true);
                    codeCount=60;
                    setCount(codeCount)
                    clearInterval(timer);
                }else{
                    codeCount=codeCount-1;
                    setCount(codeCount)
                }
            },1000);

            const res=await sendVerificationMail({email:emailval,ticket:captchaValidate,randstr:randstr,checkVersion:1});
            if(res.code==0){
                setId(res.data.id);
                toast.success("发送成功！",{toastId:'customId2'});
            }else{
                setCodeStatus(true);
                setCount(60);
                clearInterval(timer);
                toast.error(res.data||"发送失败！",{toastId:'customId2'});
            }

        }
        //删除字符串两侧空格
        const trim=(str)=>{
            return str.replace(/(^\s*)|(\s*$)/g, "");
        }
        const checkForm=()=>{
            if(id===''){
                toast.error("请先获取验证码！",{toastId:'customId'});
                return false;
            }
            if(code===''){
                toast.error("验证码不能为空！",{toastId:'customId'});
                return false;
            }
            if(password===''){
                toast.error("密码不能为空！",{toastId:'customId'});
                return false;
            }
            return true;
        }
        const handleSubmit=async()=>{
            if(loading){return ;}
            if(!checkForm()){return ;}
            if(status=='mobile'){
                const res=await verifSmsCode({pwd:password,code:code,id:id,loginMedia:(!flag?1:2),version:''});
                setLoading(true);
                if(res.code==0){
                    toast.success("重置密码成功！",{toastId:'customId2'});
                    parameters.setStatus('login');
                }else{
                    toast.error(res.data||"重置密码失败！",{toastId:'customId2'});
                }
            }else{
                const res=await verifMailCode({pwd:password,code:code,id:id,loginMedia:(!flag?1:2),version:''});
                setLoading(true);
                if(res.code==0){
                    toast.success("重置密码成功！",{toastId:'customId2'});
                    parameters.setStatus('login');
                }else{
                    toast.error(res.data||"重置密码失败！",{toastId:'customId2'});
                }
            }
            setLoading(false);
        }
        return (
            <div className={styles.reseting}>
                <h2>
                    <span className={styles.title}>{status=='mobile'?'手机号重置密码':'邮箱重置密码'}</span>
                    <span className={styles.backBtn} onClick={()=>{parameters.setStatus('login')}}>返回登录</span>
                </h2>
                {status=='mobile'?<div className={styles.phoneItem}>
                    <Select
                        placeholder="请选择地区"
                        defaultValue={Maps[0]}
                        value={selectedOption}
                        onChange={(val)=>{setSelectedOption(val);}}
                        options={Maps}
                        ref={roamRef}
                        styles={customStyles}
                        noOptionsMessage={()=>'没有搜索结果'}
                        className={styles.select}
                        classNamePrefix="selectPrefix"
                    />
                    <span className={styles.divider}></span>
                    <input type="text" className={styles.phoneInput} ref={mobileRef} value={mobile} name="resetPhone" onChange={handleMobilePost} placeholder="手机号" autoComplete="off" readOnly onFocus={(e) => e.target.removeAttribute('readOnly')} />
                </div>:<div className={styles.emailItem}>
                    <input type="text" className={styles.emailInput} ref={emailRef} value={email} name="resetEmail" onChange={handleEmailPost} placeholder="邮箱" autoComplete="off"  readOnly onFocus={(e) => e.target.removeAttribute('readOnly')} />
                </div>}
                
                <div className={styles.codeItem}>
                    <input type="text" className={styles.codeInput} placeholder="输入验证码" value={code} onChange={handleCodePost} name="resetCode" autoComplete="off" readOnly onFocus={(e) => e.target.removeAttribute('readOnly')} />
                    {codeStatus?(
                        <span className={styles.getCode} onClick={handleGetCode}>获取验证码</span>
                    ):(
                        <span className={styles.codeCount}>{count}秒</span>
                    )}
                </div>
                <div className={styles.pwdItem}>
                    <input type={pwdStatus?"text":'password'} className={styles.pwdInput}  value={password} onChange={handlePassowordPost} placeholder="输入密码" name="resetPwd" autoComplete="new-password"  readOnly onFocus={(e) => e.target.removeAttribute('readOnly')} />
                    {!pwdStatus?(
                        <span className={styles.hideEye} onClick={()=>{setPwdStatus(true)}}></span>
                    ):(
                        <span className={styles.showEye} onClick={()=>{setPwdStatus(false)}}></span>
                    )}
                </div>
                <div className={styles.statusItem}>
                    <span className={styles.loginWayBtn} onClick={()=>{setStatus(status=='mobile'?'email':'mobile')}}>{status=='mobile'?'邮箱重置密码':'手机号重置密码'}</span>
                    <input type="hidden" ref={statusRef} value={status} />
                </div>
                <div className={styles.submitItem}>
                    <button onClick={handleSubmit}>重置密码</button>
                </div>
            </div>
        );
    }catch(e){
        console.log(e);
        return null;
    } 
};

export default Reset_PC;